export const DEFAULT_IMAGE =
  "https://sharex-1.s3-eu-west-1.amazonaws.com/defaultProfilePic.png";

export const MAX_WIDTH_FOR_SYSTEM = 1000;
